import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://turcoazapps.com';
const OG_IMAGE = `${SITE_URL}/og-image.svg`;

export const SEO = ({ 
  title = 'Turcoaz Apps - Simple Tools for Digital Workflows',
  description = 'Turcoaz Apps creates clean, fast, and professional software solutions for documents, AI, and productivity. Try Smart PDF Tools today.',
  canonical,
  ogTitle,
  ogDescription,
  ogImage = OG_IMAGE,
  ogType = 'website'
}) => {
  const fullTitle = title.includes('Turcoaz Apps') ? title : `${title} | Turcoaz Apps`;
  const pageUrl = canonical ? `${SITE_URL}${canonical}` : SITE_URL;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={pageUrl} />

      {/* Open Graph */}
      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:url" content={pageUrl} />
      <meta property="og:image" content={ogImage} />
      <meta property="og:site_name" content="Turcoaz Apps" />

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />
    </Helmet>
  );
};
